module.exports={
    btn:{
        tips_reelect_btn:"Nueva imagen",
        cancel_btn:"Cancelar",
        tips_continue_dispose:"Imágenes compatibles de lujo",
        tips_return:"Nueva imagen",
        tips_upgrade:"Mejora",
        tips_yes:"DE ACUERDO",
        delete:"Borrar",
        download:"Descargar",
        upload_image:"Cargar imagen",
        new_image:"Nueva imagen",
        save_all:"Salvar a todos",
        cancel:"Cancelado",
        save:"Ahorrar",
        view_comparison:"Ver comparación",
        hide_comparison:"Ocultar comparación",
        previous:"Anterior",
        next:"Próximo",
        continue_download:"Guardar imágenes con marcas de agua",
        present:"Aplicar a esta imagen",
        all_wait:"Aplicar a imágenes en espera",
        all:"Aplicar a todas las imágenes",
        history:"Historia",
        login:"Acceso",
    },
    tips:{
        please_upgrade:"Su plan actual no admite la carga o ampliación de imágenes en lotes. Actualícelo para disfrutar de más beneficios.",
        errorlistinfo:"Se seleccionan XXX imágenes. Las imágenes XXX son compatibles, pero las imágenes XXX no lo son. Las siguientes son imágenes no admitidas:",
        max:"¡Exceda el límite máximo de tamaño de imagen de 10 MB!!",
        max_size:"¡Exceda el límite máximo de longitud del lado de la imagen de 4096px!!",
        continue_dispose:"Imágenes compatibles de lujo",
        please_multiple:"Seleccione la ampliación",
        max_multiple:"* Tu imagen se ampliará a 4K como máximo (el lado más largo no superará los 4096 px).",
        title:"Nombre",
        reasons:"Razones",
        upload_type:"No soportado",
        used_up:"El número de imágenes HD guardadas sin marcas de agua se ha agotado. Actualice su cuenta. O puede guardar imágenes HD con marcas de agua.",
        edit_multiple:"Hay varias imágenes cargadas. Seleccione las imágenes en las que desea cambiar la ampliación. Después de seleccionar, estas imágenes se ampliarán nuevamente a la nueva ampliación.",
        download_confirm:"Algunas imágenes aún se están procesando. ¿Estás seguro de guardar todas las imágenes mejoradas? Cuando guarde la misma imagen repetidamente, su número de imágenes guardadas no se deducirá nuevamente.",
        waiting_save:"Algunas imágenes aún se están procesando. Por favor, guarde más tarde.",
        
    },
    header:{
        title:"AnyMP4 Image Upscaler en línea",
        hd:" imágenes HD",
        watermarks:"sin marcas de agua se puede descargar en la actualidad.",
        view_details:"Ver detalles",
        loading:"Cargando…",
    },
    content:{
        failed:"Fallido",
        completed:"Terminado",
        processing:"Procesando",
        img_processing:"Procesando…",
        img_failed:"No se pudo procesar",
        uploading:"Subiendo",
        img_uploading:"Subiendo…",
        wait_upoading:"Esperando para subir…",
        waiting:"Espera",
        img_waiting:"Esperando…",
        empty:"Vacío",
        magnification:"Aumento:",
        drop:"¡O suelte su archivo de imagen aquí para ampliar y mejorar!",
        original:"Original:",
        output:"Producción:",
    },
    banner_msg:"Elija un plan para Image Upscaler",
    monthly:"MENSUAL",
    lifetime:"TODA LA VIDA",
    choose_plan:"Elige tu plan según el número de imágenes",
    return_home:"¡Felicidades! Ha actualizado con éxito. Vuelva a la página de inicio y utilice este producto.",
    congratulations:"¡Felicidades! Ha actualizado con éxito. Los beneficios se vincularon a la dirección de correo electrónico que dejó durante la actualización. Utilice la cuenta registrada o vinculada a la dirección de correo electrónico para",
    login_benefits:"iniciar sesión para usar los beneficios",
    no_registered:". Si no ha registrado o vinculado una cuenta con la dirección de correo electrónico, por favor",
    register_account:"utilizar la dirección de correo electrónico para registrar una cuenta",
    other_accounts:" o vincule otras cuentas a esta dirección de correo electrónico para usar los beneficios.",
    btn_close:"Cerca",
    free:"Gratis",
    btn_get_started:"Empezar",
    // access_to:"El acceso a los",
    upscale_images:"El acceso a los",
    up_to:"Hasta ",
    per_image:" por imagen",
    resolution_of:"Hasta la resolución de",
    default_level:"Imágenes mejoradas en el nivel predeterminado",
    image_downloads:"2 descargas de imágenes HD sin marca de agua",
    unlimited_image:"Descargas ilimitadas de imágenes con marca de agua",
    SHA256_encryption:"Técnica de cifrado SHA256",
    mon:"Mensual",
    images:"imágenes",
    high_resolution:" con calidad de alta resolución",
    tax_incl:"Impuestos incluidos.",
    image:"imagen",
    secure_checkout:"Pago seguro",
    everything:"Todo en Gratis, y",
    upscaling_levels:"Se pueden seleccionar todos los niveles de mejora",
    unlimited_image_without:"Descargas ilimitadas de imágenes sin marca de agua",
    viewable_editing:"El historial de edición visible es válido para",
    days:" días",
    high_level:"Nivel alto",
    priority_processing:" procesamiento prioritario",
    left:"Toda la vida",
    resolution:" resolución",


    "history_will":"Caducará después",
    "history.days":"Días)",
    "history.hours":"horas",
    "expired":"Venció",
    "access_to":"Con la prueba gratuita solo puede",
    "pricing.upload_images":"Subir imágenes",
    "pricing.under":"bajo",
    "pricing.images":"imágenes",
    "pricing.without_watermark":"sin marca de agua",
    "pricing.process_images":"Procesar imágenes hasta",
    "pricing.pixels":"píxeles",
    "pricing.enjoy_limited":"Disfrute de calificaciones exclusivas limitadas",
    "pricing.download":"Descargar",
    "pricing.HD_images":"Imágenes HD sin marca de agua",
    "pricing.and_you":"Y usted puede sufrir de",
    "pricing.slow_upscaling":"mejora lenta",
    "pricing.lower_priority":"menor prioridad",
    "pricing.without":"sin marcador de agua",
    "pricing.tax":"Los impuestos están incluidos en el precio de venta y se calcularán automáticamente en función de su país y región. En el carrito de compras puede ver el monto del impuesto detallado. El monto de su pago final será el mismo que el precio mostrado.",
    "pricing.you_can":"Con suscripción puedes",
    "pricing.up_to":"Sube imágenes hasta",
    "pricing.upscale_images":"Imágenes de lujo con",
    "pricing.no_watermark":"sin marca de agua",
    "pricing.enhance":"Mejorar",
    "pricing.or_more":"imágenes o más",
    "pricing.in_batch":"en lote",
    "pricing.enlarge_images":"Ampliar imágenes en",
    "pricing.and":"y",
    "pricing.times_with":"veces sin límite",
    "pricing.enjoy":"Disfrutar",
    "pricing.of_history":"del tiempo de almacenamiento de la historia",
    "pricing.experience":"Experiencia",
    "pricing.fast_upscaling":"escalado rápido",
    "pricing.higher_priority":"mayor prioridad",
    "pricing.early_access":"Acceso anticipado a nuevas funciones",
    "pricing.cancel_anytime":"Cancelar en cualquier momento",
    "pricing.lifetime_license":"Con licencia de por vida puede",
    "pricing.and_there":"y habrá",
    "pricing.no_expiration":"sin fecha de vencimiento",
    "pricing.unless":"a menos que se agoten todos los upscales",
}